<template>
  <div>
    <form>
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link :to="{ name: 'advertising_list', params: { search: search } }" class="btn btn-ptc1" tag="button">返回</router-link>
        </b-col>
        <b-col class="text-center title">行銷活動 / 首頁廣告管理 / 新增</b-col>
        <b-col>
          <div class="text-right">
            <button type="button" class="btn btn-save" @click="save">儲存</button>
            <button type="button" class="btn btn-clear" @click="clear">清除</button>
          </div>
        </b-col>
      </b-row>

      <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">標題</label>
                  <input type="text" class="form-control" v-model.trim="title" maxlength="100" placeholder="請輸入廣告標題">
                  <div class="text-danger" v-if="valid_title&&!title">{{valid_title}}</div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">圖片上傳</label>
                  <div class="form-group">
                    <div class="col-lg-12 block">
                      <img class="front_img" src="../../../assets/preview/phone.png">
                      <div class="bk_div">
                        <input type="file" class="upload_input" id="pic" ref="inputer" accept="image/*" multiple @change="handleFileChange">
                        <label class="upload_block" for="pic">
                          <span class="upload_icon">➕</span>
                          <img class="upload_img" v-if="img_url != undefined" :src="img_url">
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="text-danger" v-if="valid_img_url">{{valid_img_url}}</div>
                  <span class="text-danger">※限制上傳一張圖片，建議尺寸為750x1334</span>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="control-label">開始日期</label>
                      <input type="date" class="form-control" v-model="sdate" :min="today" max="9999-12-31">
                      <div class="text-danger" v-if="valid_sdate">{{valid_sdate}}</div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="control-label">結束日期</label>
                      <input type="date" class="form-control" v-model="edate" :min="sdate?sdate:today" max="9999-12-31">
                      <div class="text-danger" v-if="valid_edate">{{valid_edate}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group">
                      <label class="control-label">對應行銷活動</label>
                      <select class="form-control" v-model="ddl_type" @change="ddlTypeChange">
                        <option value="0">無</option>
                        <option value="1">最新活動</option>
                        <option value="2">新開幕</option>
                        <option value="3">APP公告</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <div class="form-group">
                      <label class="control-label">&nbsp;</label>
                      <select class="form-control" v-model="ddl_event" :disabled="ddl_type==0">
                        <option value="0" disabled>請選擇活動主題</option>
                        <option v-for="x in events" :value="x.ID" :key="x.ID">{{x.Title}}</option>
                      </select>
                      <div class="text-danger" v-if="valid_ddl_event&&ddl_event==0">{{valid_ddl_event}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">連結文字顏色</label>
                  <input type="color" class="form-control" style="width:100px" v-model="link_color">
                </div>
              </div>
            </div>
          </div>
        </b-card>

        <!-- Double Check Modal -->
        <b-modal ref="mdCheck" hide-footer title="首頁廣告變更">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <label class="control-label">確定新增此則廣告 ?</label>
              </div>
              <div class="float-right">
                <b-btn variant="primary" @click="confirm">確定</b-btn>
                <b-btn variant="secondary" @click="cancel">取消</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>

      </div>
    </form>
  </div>
</template>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL, fileUploadMaxSize} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      title: '',
      img_url: undefined,
      today: '',
      sdate: '',
      edate: '',
      ddl_type: 0,
      ddl_event: 0,
      events: [],
      link_color: '#428bca',
      valid_errMsg: false,
      valid_title: '',
      valid_img_url: '',
      valid_sdate: '',
      valid_edate: '',
      valid_ddl_event: '',
      search: {}, // 記錄查詢條件
      FunctionPermission: 0
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F04') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    } else if (this.FunctionPermission < 2) {
      this.$router.push({ name: 'advertising_list' })
      return
    }

    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
    }

    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    this.today = year + '-' + mon + '-' + day
  },
  props: {
    value: {
      default: undefined
    }
  },
  methods: {
    clear () {
      const input = this.$refs.inputer
      input.type = 'text'
      input.type = 'file'

      this.title = ''
      this.img_url = undefined
      this.sdate = null
      this.edate = null
      this.ddl_type = 0
      this.ddl_event = 0
      this.events = []
      this.link_color = '#428bca'

      this.valid_errMsg = false
      this.valid_title = ''
      this.valid_img_url = ''
      this.valid_sdate = ''
      this.valid_edate = ''
      this.valid_ddl_event = ''
    },
    save () {
      this.valid_errMsg = false

      if (!this.title) {
        this.valid_errMsg = true
        this.valid_title = '標題為必填'
      }
      if (!this.img_url) {
        this.valid_errMsg = true
        this.valid_img_url = '圖片為必選'
      }
      if (!this.sdate) {
        this.valid_errMsg = true
        this.valid_sdate = '日期格式不正確'
      } else if (this.sdate < this.today) {
        this.valid_errMsg = true
        this.valid_sdate = '開始日期不得小於系統時間'
      }
      if (!this.edate) {
        this.valid_errMsg = true
        this.valid_edate = '日期格式不正確'
      } else if (this.edate < this.sdate) {
        this.valid_errMsg = true
        this.valid_edate = '結束日期不得小於開始日期'
      }
      if (this.ddl_type != 0 && this.ddl_event == 0) { //eslint-disable-line
        this.valid_errMsg = true
        this.valid_ddl_event = '活動主題為必選'
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCheck.show()
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      this.$parent.Loading = true

      var linkType = 0
      if (this.ddl_type != 0) { //eslint-disable-line
        linkType = 1
      }

      let formData = new FormData()
      formData.append('title', this.title)
      formData.append('image', this.file)
      formData.append('sdate', this.sdate)
      formData.append('edate', this.edate)
      formData.append('linkType', linkType)
      formData.append('linkEventID', this.ddl_event)
      formData.append('linkColor', this.link_color)

      return axios.post(API_URL + '/web/marketing/createadvertising/v1',
        formData
      )
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('首頁廣告已新增')
            this.$router.push({ name: 'advertising_list', params: { search: this.search } })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增失敗')
          console.log(error)
        })
    },
    ddlTypeChange () {
      this.ddl_event = 0
      this.events = []

      if (this.ddl_type == 0) { //eslint-disable-line
        this.valid_ddl_event = ''
      } else {
        this.$parent.Loading = true
        return axios.post(API_URL + '/web/marketing/getallevents/v1', {
          targetType: Number(this.ddl_type)
        })
          .then((response) => {
            this.$store.commit('TOKEN', response.data.jwt)
            this.$parent.Loading = false

            if (response.data.result === '0000') {
              this.events = response.data.data
            } else if (response.data.result === '0006') {
              this.$parent.logOut(true, true)
            } else {
              miniToastr.error(response.data.message, '行銷活動讀取異常')
              console.log(response.data.message)
            }
          })
          .catch((error) => {
            this.$parent.Loading = false
            miniToastr.error(error, '行銷活動讀取異常')
            console.log(error)
          })
      }
    },
    handleFileChange (e) {
      this.valid_img_url = ''
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.img_url = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.img_url = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    }
  },
  watch: {
    sdate: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_sdate = '日期格式不正確'
        } else if (val < this.today) {
          this.valid_sdate = '開始日期不得小於系統時間'
        } else {
          this.valid_sdate = ''
        }
      }
    },
    edate: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_edate = '日期格式不正確'
        } else if (val < this.sdate) {
          this.valid_edate = '結束日期不得小於開始日期'
        } else {
          this.valid_edate = ''
        }
      }
    }
  }
}
</script>
<style scoped>
.upload_block {
  position: relative;
  width: 257px;
  height: 450px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 46%;
}
.block {
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 55pt;
  left: 25pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 2;
}
.bk_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/advertising/Add.vue